const keyword = {
  additionalPaymentInfo: 'Zusatzinformationen',
  advertisement: 'Anzeige',
  appStore: 'App store',
  ariaLabelControls: 'Karussellsteuerung',
  back: 'Zurück',
  cameraPermissionDenied: 'Kameraberechtigung verweigert',
  cashPayment: 'Barzahlung',
  category: 'Kategorie',
  choose: 'Auswählen',
  city: 'Ort',
  clock: 'Uhr',
  close: 'Schließen',
  companyInfo: 'Adresszusatz/Firma',
  delivery: 'Botendienst',
  deliveryConditions: 'Lieferkonditionen',
  deliveryInactive: 'Abholung',
  deliveryMethods: 'Lieferarten',
  email: 'E-Mail-Adresse',
  emergencyService: 'Notdienst',
  errorHasOccurred: 'Leider ist ein Fehler aufgetreten.',
  expressDelivery: 'Express-Lieferung',
  filter: 'filtern',
  filter2: 'Filter',
  firstName: 'Vorname',
  free: 'kostenfrei',
  googlePlay: 'Google play',
  here: 'hier',
  houseNumber: 'Hausnummer',
  insteadOf: 'statt',
  lastName: 'Nachname',
  magazines: 'Magazine',
  manufacturer: 'Hersteller',
  medicine: 'Medikament',
  medicines: 'Medikamenten',
  menu: 'Menü',
  messengerService: 'Botendienst möglich',
  more: 'mehr',
  myLife: 'my life E-paper',
  no: 'Nein',
  note: 'Bemerkung',
  offers: 'Angebote',
  on: 'am',
  onlinePayment: 'Online-Zahlung',
  onsitePayment: 'Zahlung vor Ort',
  open: 'Geöffnet',
  openingHours: 'Öffnungszeiten',
  orders: 'Bestellungen',
  owner: 'Inhaber',
  password: 'Passwort',
  paymentLogos: 'Zahlungslogos',
  paymentMethods: 'Zahlarten',
  phoneNumber: 'Telefonnummer',
  pharmacy: 'Apotheke',
  pickup: 'Abholung',
  place: 'Ort',
  product: 'Produkt',
  productCarousel: 'Produktkarussell',
  products: 'Produkte',
  register: 'Anmelden',
  registration: 'Anmeldung',
  remarks: 'Anmerkungen',
  salutation: 'Anrede',
  search: 'Suche',
  serviceOffering: 'Serviceangebot',
  partnerPrograms: 'Partnerprogramme',
  shoppingCart: 'Warenkorb',
  signIn: 'Anmelden',
  signOut: 'Abmelden',
  slide: 'Gleiten',
  street: 'Straße',
  toCart: 'Zum Warenkorb',
  today: 'Heute',
  use: 'Anwenden',
  user: 'Benutzer',
  userData: 'Benutzerdaten',
  whatsApp: 'WhatsApp',
  yes: 'Ja',
  zipCode: 'PLZ',
}

export default keyword
